module.exports = __webpack_public_path__ + "static/media/icnVolverInicio.f7e32684.svg";